import { createFileRoute } from '@tanstack/react-router';
import { FeedbackScreen, type FeedbackSearch } from '@/features/feedback/FeedbackScreen';
import { isSectionKey } from '@/lib/access';

const SEGMENTS = ['bug', 'idea', 'question', 'other'] as const;

/** /feedback, with optional deep-link search params: `?from=help&topic=<slug>`
 *  (Help's "No, ask a person"), `?type=bug|idea|question|other`, and
 *  `?feature=<section>` (the Early access strip's "Send feedback", which
 *  tags the message with the section; docs/ACCESS.md). */
export const Route = createFileRoute('/_app/feedback')({
  validateSearch: (s: Record<string, unknown>): FeedbackSearch => ({
    from: typeof s.from === 'string' && s.from ? s.from : undefined,
    topic: typeof s.topic === 'string' && s.topic ? s.topic.slice(0, 80) : undefined,
    type: SEGMENTS.find((t) => t === s.type),
    feature: isSectionKey(s.feature) ? s.feature : undefined,
  }),
  component: FeedbackRoute,
});

function FeedbackRoute() {
  const search = Route.useSearch();
  return <FeedbackScreen search={search} />;
}
